import React from 'react';
import BrandConsolidation from '@homeaway/react-brand-consolidation';
import IsBrowser from '../IsBrowser';
import { Experiment } from '../Experiment';

const BrandConsolidationBanner = ({ siteName, isMobile, showConsolidationBanner }) => (
  <Experiment name={'HA_GX_brandConsolidation'}>
    {value => (value === 1 || (!isMobile && showConsolidationBanner)) &&
      <IsBrowser>
        <BrandConsolidation siteName={siteName} />
      </IsBrowser>
    }
  </Experiment>
);

export default BrandConsolidationBanner;
